<template>
  <div class="in-fo">
    <div class="info-top">
      <img class="top-bg" src="../imgs/m-bg.png" alt />
      <img class="header-img" :src="headerimg" alt />
      <div class="user-name">{{userName}}</div>
    </div>
    <div class="info-form">
      <div class="user-info">
        <div class="info-t">身份信息</div>
        <img :src="realName" alt />
      </div>
      <van-form>
        <van-field
          input-align="right"
          v-model="formData.nickName"
          label="姓名"
          placeholder="姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          input-align="right"
          v-model="formData.phone"
          label="联系方式"
          placeholder="联系方式"
          :rules="[{ required: true, message: '请填写联系方式' }]"
        />
        <!-- <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>-->
      </van-form>
    </div>
    <van-checkbox shape="square" checked-color="#FC6C21" icon-size="10px" v-model="checked">第一次注册信息保存后将进行实名认证。</van-checkbox>
    <div class="info-but">
      <van-button @click="onSubmit" round color="linear-gradient(to right, #ed3045 ,#ff6034)">保存</van-button>
    </div>
  </div>
</template>

<script>
import URLTC from "@/api/apiTC";
import { Toast } from 'vant';
export default {
  data() {
    return {
      headerimg: require(`../../assets/publicImg/user.png`),
      realName: require('@/assets/publicImg/real-name.png'),//是否实名图标
      userName:'',
      formData: {
        username: '',
        phone: '',
      },
      checked: true,
      isReal:'',//是否实名
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    getData(){
      let userId = localStorage.getItem('userid')
      this.$fetchGet(URLTC.getInfo.url, { userId: userId }).then(res=>{
        if(res.data.code==20000){
          this.headerimg=res.data.data.avatarName || require(`../../assets/publicImg/user.png`)
          this.userName=res.data.data.realName || res.data.data.nickName
          this.formData=res.data.data
          this.isReal=res.data.data.realName
          if(this.isReal){
            this.realName= require('@/assets/publicImg/real-name1.png')//是否实名图标
          }
        }
      })
    },
    onSubmit(){
      if(this.checked==false){
        Toast('请勾选第一次保存协议')
        return
      }
      let data={
        nickName:this.formData.nickName,
        phone:this.formData.phone,
        id: localStorage.getItem('userid')
      }
      this.$fetchPost(URLTC.changeInfo.url, data).then(res=>{
        if(res.data.code==20000){
          if(!this.isReal){
            this.$router.push('/identityCheck')
          }else{
            Toast(res.data.msg)
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.in-fo {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  font-weight: 500;
  .info-top {
    text-align: center;
    .top-bg {
      width: 375px;
      height: 50px;
    }
    .header-img {
      margin-top: -35px;
      width: 65px;
      border-radius: 50%;
    }
    .user-name {
      line-height: 15px;
      font-size: 14px;
      color: #333333;
    }
  }
  .info-form {
    .user-info {
      display: flex;
      font-size: 14px;
      color: #333333;
      .info-t {
        margin: 43px 10px 15px 38px;
      }
      img {
        width: 35px;
        height: 12px;
        margin-top: 45px;
      }
    }
    .van-cell {
      padding: 10px 38px;
    }
  }
  .van-checkbox {
    margin: 185px auto auto 38px;
    font-size: 9px;
    color: #999;
    // /deep/.van-icon {
    //   color: rgb(252, 108, 33);
    //   background-color: #fff;
    //   border-color: rgb(252, 108, 33);
    // }
  }
  .info-but {
    text-align: center;
    margin-top: 10px;
    .van-button {
      width: 185px;
      height: 30px;
    }
  }
}
</style>